var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("highcharts", {
    ref: "highchart",
    class: {
      "highcharts-custom--disable-drilldown": !_vm.enableDrilldown,
      "highcharts-custom--disable-drillup": _vm.chartDrilleddownTo === -1
    },
    attrs: { options: _vm.columnChartOptions }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }